import PropTypes from 'prop-types';
import React from 'react';

import Typography   from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Container    from '@mui/material/Container';

import ReactHtmlParser from 'react-html-parser';

function Article({ name, description }) {
  const theme = useTheme();

  if (!description) { return null; }

  return (
    <Container sx={{
      mb:                             6,
      [theme.breakpoints.down('sm')]: {
        mb:      3,
        p:       3,
        bgcolor: theme.palette.grey['100'],
      },
    }}
    >
      <Typography
        variant="h4"
        color="primary"
        data-testid="article-company-name"
        sx={{
          fontWeight:                     'bold',
          mb:                             3,
          [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
          },
        }}
      >
        {`${t('eos.landing_page.text.about_company', { company: name })}`}
      </Typography>
      <Typography
        variant="body"
        component="div"
        data-testid="article-company-description"
        sx={{
          fontSize:   '.9rem',
          lineHeight: '1.5',
          a:          {
            color:          'primary.main',
            textDecoration: 'none',
            '&:hover':      {
              textDecoration: 'underline',
            },
          },
        }}
      >
        {ReactHtmlParser(description)}
      </Typography>
    </Container>
  );
}

Article.defaultProps = {
  name:        null,
  description: null,
};

Article.propTypes = {
  name:        PropTypes.string,
  description: PropTypes.string,
};

export default Article;
